var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMastercard = function SvgMastercard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": true,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.02 10.505h5.923v10.857H13.02z",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.396 15.935a6.944 6.944 0 0 1 2.585-5.43c-2.775-2.224-6.76-1.9-9.156.745s-2.395 6.723 0 9.368 6.38 2.969 9.156.744a6.944 6.944 0 0 1-2.585-5.427z",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.934 15.935c0 2.643-1.48 5.054-3.81 6.21s-5.105.851-7.143-.783a6.955 6.955 0 0 0 2.587-5.428c0-2.118-.954-4.12-2.587-5.429 2.038-1.633 4.81-1.937 7.142-.782s3.811 3.566 3.811 6.21z",
    fill: "#f79e1b"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjMyIiB3aWR0aD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMzJ2MzJIMHoiIGZpbGw9IiMwMDAiPjwvcGF0aD48ZyBmaWxsLXJ1bGU9Im5vbnplcm8iPjxwYXRoIGQ9Ik0xMy4wMiAxMC41MDVoNS45MjN2MTAuODU3SDEzLjAyeiIgZmlsbD0iI2ZmNWYwMCI+PC9wYXRoPjxwYXRoIGQ9Ik0xMy4zOTYgMTUuOTM1YTYuOTQ0IDYuOTQ0IDAgMCAxIDIuNTg1LTUuNDNjLTIuNzc1LTIuMjI0LTYuNzYtMS45LTkuMTU2Ljc0NXMtMi4zOTUgNi43MjMgMCA5LjM2OCA2LjM4IDIuOTY5IDkuMTU2Ljc0NGE2Ljk0NCA2Ljk0NCAwIDAgMS0yLjU4NS01LjQyN3oiIGZpbGw9IiNlYjAwMWIiPjwvcGF0aD48cGF0aCBkPSJNMjYuOTM0IDE1LjkzNWMwIDIuNjQzLTEuNDggNS4wNTQtMy44MSA2LjIxcy01LjEwNS44NTEtNy4xNDMtLjc4M2E2Ljk1NSA2Ljk1NSAwIDAgMCAyLjU4Ny01LjQyOGMwLTIuMTE4LS45NTQtNC4xMi0yLjU4Ny01LjQyOSAyLjAzOC0xLjYzMyA0LjgxLTEuOTM3IDcuMTQyLS43ODJzMy44MTEgMy41NjYgMy44MTEgNi4yMXoiIGZpbGw9IiNmNzllMWIiPjwvcGF0aD48L2c+PC9nPjwvc3ZnPgo=";